import { FormattedMessage } from 'react-intl';
import { handleNullableString } from 'utils/helpers';

import { TCDashboardTabProps } from './types';

import * as S from './styles';

const TCDashboardTab: React.FC<TCDashboardTabProps> = ({
  type,
  name,
  state,
  amount,
  keyName,
  onSelect,
}) => {
  const handleTabSelection = () => {
    onSelect(name);
  };

  // Just for react-intl pluralisation purposes
  const isPlural = 2;

  const amountInfo = handleNullableString('-', amount?.toString());

  return type === 'large' ? (
    <S.LargeTab
      state={state}
      onClick={handleTabSelection}
      data-testid={`TCDashboardTab-${name}`}
    >
      <S.TabAmount>{amountInfo}</S.TabAmount>
      <S.TabText>
        <FormattedMessage
          id={keyName}
          values={{ amount: amount || isPlural }}
        />
      </S.TabText>
    </S.LargeTab>
  ) : (
    <S.SmallTab
      state={state}
      onClick={handleTabSelection}
      data-testid={`TCDashboardTab-${name}`}
    >
      <S.TabText>
        <b>{amountInfo}</b>
        <FormattedMessage id={keyName} values={{ amount }} />
      </S.TabText>
    </S.SmallTab>
  );
};

export default TCDashboardTab;
